
export default {
  scrollToTop: true,
  props: {
    id: {
      type: String,
      default: null
    }
  },
  async asyncData ({ $content, params, app: { i18n: { locale }, $seoMeta } }) {
    const category = await $content(locale, 'menus', params.id).fetch()
    $seoMeta.update($seoMeta.page(category.seoMeta))

    return { category }
  }
}
